/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BasicErrorDetailsErrorResponseModel,
  BlobFileType,
} from '../models/index';
import {
    BasicErrorDetailsErrorResponseModelFromJSON,
    BasicErrorDetailsErrorResponseModelToJSON,
    BlobFileTypeFromJSON,
    BlobFileTypeToJSON,
} from '../models/index';

export interface BlobDownloadFileGETRequest {
    blobUrl?: string;
    fileType?: BlobFileType;
}

/**
 * BlobApi - interface
 * 
 * @export
 * @interface BlobApiInterface
 */
export interface BlobApiInterface {
    /**
     * Creates request options for blobDownloadFileGET without sending the request
     * @param {string} [blobUrl] 
     * @param {BlobFileType} [fileType] 
     * @throws {RequiredError}
     * @memberof BlobApiInterface
     */
    blobDownloadFileGETRequestOpts(requestParameters: BlobDownloadFileGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [blobUrl] 
     * @param {BlobFileType} [fileType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobApiInterface
     */
    blobDownloadFileGETRaw(requestParameters: BlobDownloadFileGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    blobDownloadFileGET(requestParameters: BlobDownloadFileGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

}

/**
 * 
 */
export class BlobApi extends runtime.BaseAPI implements BlobApiInterface {

    /**
     * Creates request options for blobDownloadFileGET without sending the request
     */
    async blobDownloadFileGETRequestOpts(requestParameters: BlobDownloadFileGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['blobUrl'] != null) {
            queryParameters['blobUrl'] = requestParameters['blobUrl'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['fileType'] = requestParameters['fileType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Blob/download`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async blobDownloadFileGETRaw(requestParameters: BlobDownloadFileGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.blobDownloadFileGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async blobDownloadFileGET(requestParameters: BlobDownloadFileGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.blobDownloadFileGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
